
import { createApiClient } from 'Network/ApiClient';

export const ActivityCustomAxiosInstance = createApiClient('activitycustom/');


